import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function CustomModal({
  title,
  children,
  setOpen,
  open,
  padding = 0,
  margin = 0,
  minWidth = 'initial',
  maxWidth = 'initial',
  borderRadius = '6px',
  backDropClose = false
}) {
  const handleClose = (event, reason) => {
    if (backDropClose) {
      if (reason && reason == 'backdropClick') {
        return;
      }
      setOpen(false);
    } else {
      setOpen(false);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        maxWidth="md"
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            borderRadius: borderRadius
          }
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        >
          <DialogTitle style={{ padding: '16px' }}>
            {title ? title : ''}{' '}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500]
            })}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent
          style={{
            height: '100%',
            padding: padding,
            margin: margin,
            scrollbarWidth: 'thin', // For Firefox
            '&::-webkit-scrollbar': {
              width: '6px' // Adjust this value to control width for WebKit browsers (Chrome, Safari)
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#888' // Customize thumb color
            }
          }}
        >
          {children}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
